module.exports = __webpack_public_path__ + "img/scalability-6.2fcb3f9a.png";